
var recaptchaId;
export function onLoadRecaptcha(callback){
    window.onLoadRecaptcha = function() {
        var key = $("input[name=recaptchaSiteKey]").val();
        if (key === '') {
            return;
        }

        recaptchaId = grecaptcha.render('recaptchaPhone', {
            sitekey: key,
            size: 'invisible',
            callback: function (token) {
                callback(token);
                if ($("input[name=recaptchaSiteKey]").val() !== '') {
                    grecaptcha.reset(recaptchaId);
                }
            }
        });
    }
};

export function executeCaptcha(executeWithoutCallback, finishCallback) {
    if ($("input[name=recaptchaSiteKey]").val() === '') {
        executeWithoutCallback();
    } else {
        if (typeof grecaptcha === 'undefined') {
            $.getScript("https://www.google.com/recaptcha/api.js?onload=onLoadRecaptcha&render=explicit", function () {
                executeRecaptcha();
                setTimeout(finishCallback, 1500);
            });
        } else {
            executeRecaptcha();
            setTimeout(finishCallback, 1000);
        }
    }
}

function executeRecaptcha() {
    if (typeof grecaptcha.render !== 'undefined') {
        var recaptchaPhone = $('#recaptchaPhone');
        recaptchaPhone.addClass('active');
        recaptchaPhone.css("cssText", "top: " + $(document).scrollTop() + "px");
        grecaptcha.execute(recaptchaId);
    } else {
        setTimeout(executeRecaptcha, 10);
    }
}

